import React from 'react';
import { Ruler, Lightbulb, LayoutGrid } from 'lucide-react';

export default function QuickStats({ sections, parameters }) {
  // Calculate stats
  const totalSections = sections?.length || 0;
  const totalLighting = sections?.reduce((sum, section) => sum + (section.length_feet || 0), 0) || 0;
  
  // Calculate estimated pucks based on light spacing
  const lightSpacing = parameters?.light_spacing_inches || 12;
  const lightsPerFoot = 12 / lightSpacing;
  const estimatedPucks = Math.ceil(totalLighting * lightsPerFoot);

  const stats = [
    {
      label: 'Total Sections',
      value: totalSections,
      icon: LayoutGrid,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50'
    },
    {
      label: 'Total Lighting',
      value: `${totalLighting.toFixed(1)}'`,
      icon: Ruler,
      color: 'text-amber-600',
      bgColor: 'bg-amber-50'
    },
    {
      label: 'Estimated Pucks',
      value: estimatedPucks,
      icon: Lightbulb,
      color: 'text-green-600',
      bgColor: 'bg-green-50'
    }
  ];

  return (
    <div className="space-y-3">
      <h3 className="font-semibold text-slate-900">Quick Stats</h3>
      <div className="grid grid-cols-1 gap-3">
        {stats.map((stat) => {
          const Icon = stat.icon;
          return (
            <div
              key={stat.label}
              className={`flex items-center justify-between p-4 rounded-lg ${stat.bgColor} border border-slate-200`}
            >
              <div className="flex items-center gap-3">
                <div className={`p-2 rounded-lg bg-white ${stat.color}`}>
                  <Icon className="w-5 h-5" />
                </div>
                <span className="text-sm font-medium text-slate-700">{stat.label}</span>
              </div>
              <span className="text-2xl font-bold text-slate-900">{stat.value}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
